import { createRouter, createWebHistory } from 'vue-router';
import baseRoutes from './routes/baseRoutes';
import { announceNewPageToScreenReaders, guardNavigation } from './routerUtils';

const routes = baseRoutes(guardNavigation);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(announceNewPageToScreenReaders);

export default router;
